import React, { Component } from 'react';
import BrowseElementList from './BrowseElementList';
import BrowseListContainer from './BrowseListContainer';
import { compose } from 'redux';
import { injectIntl, intlShape, defineMessages } from 'react-intl';
import composers from './data/composers';
import * as clientActions from '../../actions/client';
import { getBaseHelmet } from '../../utils/browse';

const messages = defineMessages({
  popularComposers: {
    id: 'browse.composers.popular',
    defaultMessage: 'Popular Composers',
  },
  moreComposers: {
    id: 'browse.composers.more',
    defaultMessage: 'More Composers',
  },
});

class BrowseComposers extends Component {
  static propTypes = {
    intl: intlShape,
  };

  static onDataFetch(store, params, location, intl) {
    store.dispatch(
      clientActions.setHelmet({
        ...getBaseHelmet(intl),
        canonicalRoute: '/browse/composers',
      })
    );
  }

  render() {
    const { intl } = this.props;
    const { formatMessage } = intl;

    const popular = formatMessage(messages.popularComposers);
    const unpopular = formatMessage(messages.moreComposers);
    return (
      <React.Fragment>
        <BrowseListContainer
          title={popular}
          link="/composers"
          category="Composers"
          linkTitle="viewAll"
        >
          <BrowseElementList items={composers.popular} />
        </BrowseListContainer>
        <BrowseListContainer
          title={unpopular}
          link="/composers"
          category="Composers"
          linkTitle="viewAll"
        >
          <BrowseElementList items={composers.unpopular} />
        </BrowseListContainer>
      </React.Fragment>
    );
  }
}

export default compose(injectIntl)(BrowseComposers);
